import React from 'react'
import styled from 'styled-components'
import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import Group from 'components/utils/Group'

const IconContainer = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.six};
  width: 100%;
`

function EmptyMustDoImage() {
  return (
    <IconContainer direction="vertical" verticalAlign="center" horizontalAlign="center">
      <LineMapMarkerIcon size="XL" />
    </IconContainer>
  )
}

export default EmptyMustDoImage
